/** @format */
import styled from 'styled-components';

import { theme } from '@toucan/client/global/theme';

import { ProductComparisonItemHeader } from '../../product-comparison-item.styles';

// eslint-disable-next-line @mpb-com/mpb/no-exported-styled-component, @mpb-com/mpb/styled-component-prefix -- Legacy code: do not use as an example.
/* eslint-disable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
// eslint-disable-next-line @mpb-com/mpb/no-exported-styled-component, @mpb-com/mpb/styled-component-prefix -- Legacy code: do not use as an example.
export const ProductComparisonItemErrorHeader = styled(
    ProductComparisonItemHeader
)`
    ${theme.typography.body_small_highlight}
    grid-template-columns: 1fr;
    justify-items: center;
    white-space: nowrap;

    .product-comparison-item-error-message {
        align-self: end;
    }

    .product-comparison-item-refresh-button {
        align-self: start;
    }
`;
/* eslint-enable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
